import { Dayjs } from 'dayjs';

export enum ViewMode {
  day = 'day',
  week = 'week',
  month = 'month',
}

export enum AppointmentType {
  medicalcare = 'medicalcare',
  medicine_delivery = 'medicine_delivery',
}
export interface AppointmentImageAttachment {
  type?: string | null;
  authorName?: string | null;
  title?: string | null;
  titleLink?: string | null;
  text?: string | null;
  imageURL?: string | null;
  thumbURL?: string | null;
  assetURL?: string | null;
  ogScrapeURL?: string | null;
  extraInfo?: any;
}

export type Appointment = {
  id: string;
  patientUserId?: string;
  patientEmail: string;
  doctorUserId?: string;
  doctorEmail: string;
  patientName?: string;
  startedAt?: string;
  endedAt?: string;
  notes: string;
  rtcChannelId: string;
  startedAtCandidates?: string[];
  createdAt?: string;
  amount?: number;
  prescription?: string;
  imageAttachments?: AppointmentImageAttachment[];
  appointmentType?: AppointmentType;
  canceled?: boolean;
  canceledReason?: string;
  confirmCancel?: boolean;
  paidAt?: string;
  confirmPaid?: boolean;
  doctorDepartment?: string;
  doctorHospital?: string;
  isInsurance: boolean | null;
  patientInfo?: PatientInfo;
  patientInfoId?: string;
  timeForSorting?: string | null;
  extraInfo?: Record<string, any>;
};

export type PatientInfo = {
  address: string;
  birthDay: string;
  birthMonth: string;
  birthYear: string;
  insuranceImageBack: AppointmentImageAttachment;
  insuranceImageFront: AppointmentImageAttachment;
  insuranceNumber: string;
  name: string;
  phone: string;
  sex: string;
  zipPrefix: string;
  zipSuffix: string;
};

export type AppointmentStatus = Omit<
  Appointment,
  'startedAt' | 'endedAt' | 'id'
> & {
  id?: string;
  startedAt?: Dayjs;
  endedAt?: Dayjs;
  imageURL?: string | null;
};

export type PrescriptionType = 'paper' | 'electronic';

export enum ScreenView {
  calendarView = 'calendarView',
  editView = 'editView',
  listRequestView = 'listRequestView',
  rebookView = 'rebookView',
  hoursView = 'hoursView',
  paymentHistoryView = 'paymentHistoryView',
}

export type TimeSlotAvailability = {
  hour: number | null;
  minute: number | null;
};

export type HourAvailability = {
  from: TimeSlotAvailability;
  to: TimeSlotAvailability;
};

export type DayAvailability = {
  days: number[]; //0 - 6, 0 being Sunday
  hours: HourAvailability[];
};

export type SpecialAvailability = {
  year: number | null;
  month: number | null;
  day: number | null;
  hours: HourAvailability[];
};

export type BusinessHours = {
  timezone: string;
  weekly: DayAvailability[];
  specialDays: SpecialAvailability[];
  holidays?: {
    hours: HourAvailability[];
  };
};

export type Doctor = {
  businessHours: BusinessHours;
};

export type Pharmacy = {
  businessHours: BusinessHours;
};

export type CalendarAvailabilityDay = {
  id: string;
  isCurrentMonth: boolean;
  label: string;
  dayOfWeek: number;
  isSaturday: boolean;
  isSunday: boolean;
  holidayName?: string;
  availabilityList: HourAvailability[];
  isOffDay: boolean;
  isSpecialDay: boolean;
};

export const mockData: Doctor = {
  businessHours: {
    timezone: 'Asia/Tokyo',
    weekly: [
      {
        days: [1, 2, 3, 4, 5],
        hours: [
          {
            from: {
              hour: 8,
              minute: 30,
            },
            to: {
              hour: 12,
              minute: 30,
            },
          },
          {
            from: {
              hour: 13,
              minute: 30,
            },
            to: {
              hour: 22,
              minute: 0,
            },
          },
        ],
      },
      {
        days: [6, 0],
        hours: [
          {
            from: {
              hour: 8,
              minute: 30,
            },
            to: {
              hour: 11,
              minute: 0,
            },
          },
        ],
      },
    ],
    specialDays: [
      {
        year: null,
        month: 4,
        day: 1,
        hours: [],
      },
      {
        year: null,
        month: 4,
        day: 27,
        hours: [],
      },
      {
        year: null,
        month: 4,
        day: 28,
        hours: [],
      },
      {
        year: null,
        month: 4,
        day: 29,
        hours: [],
      },
      {
        year: null,
        month: 4,
        day: 30,
        hours: [],
      },
    ],
  },
};

export type TempDayAvailability = Omit<DayAvailability, 'hours'> & {
  hours: TempHourAvailability[];
  dayOff: boolean;
};

export type TempHourAvailability = HourAvailability & {
  hasError?: boolean;
};
